import axios from "@/plugins/axios";
import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        fetchSaleCustomerYearly(context, searchItem) {
            let url = "sale_customer_yearlies?page="  + searchItem.page + '&order[totalPurchase]=desc'

            if (!context.state.saleCustomerYearly.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.dateTo) {
                url = url + '&dateTime[before]=' + searchItem.dateTo
            }

            if (searchItem.dateFrom) {
                url = url + '&dateTime[after]=' + searchItem.dateFrom
            }

            if (searchItem.companyName) {
                url = url + "&customer.customerCompany.name=" + searchItem.companyName
            }

            if (searchItem.givenName) {
                url = url + "&customer.person.givenName=" + searchItem.givenName
            }

            if (searchItem.familyName) {
                url = url + "&customer.person.familyName=" + searchItem.familyName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleCustomerYearly', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        fetchSaleCustomerYearlyPurchaseCount(context, data) {
            if (!context.state.saleCustomerYearlyPurchaseCount.isNeedFetch) {
                return
            }

            return pushModel(context, 'sale_customer_yearlies/count', data, 'updateSaleCustomerYearlyPurchaseCount')
        }
    },
    mutations: {
        updateSaleCustomerYearly(state, data) {
            state.saleCustomerYearly = data
            state.saleCustomerYearly.isNeedFetch = false
        },
        updateSaleCustomerYearlyPurchaseCount(state, data) {
            state.saleCustomerYearlyPurchaseCount.purchaseCount = data
            state.saleCustomerYearlyPurchaseCount.isNeedFetch = false
        }
    },
    state: {
        saleCustomerYearly: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        saleCustomerYearlyPurchaseCount: {
            purchaseCount: null,
            isNeedFetch: true
        }
    },
    getters: {
        getSaleCustomerYearly(state) {
            return state.saleCustomerYearly.models
        },
        getSaleCustomerYearlyTotalCount(state) {
            return state.saleCustomerYearly.totalItems
        },
        getSaleCustomerYearlyPurchaseCount(state) {
            return state.saleCustomerYearlyPurchaseCount.purchaseCount
        }
    },
}
